import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Footer from "./includes/Footer";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { contact, clearContactMessage } from "../actions";
import ReCAPTCHA from "react-google-recaptcha";
import $ from "jquery";

class Contactus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactUsStatus: 0,
      recaptchaToken: null,
      recaptchaError: null,
    };

    window.scrollTo(0, 0); // scroll page to top
    this.contactUsForm = this.contactUsForm.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
  }

  componentDidMount() {
    let contactUsStatus;
    if (
      localStorage.getItem("contactus") === "1" ||
      window.location.href.includes("/promo-code")
    ) {
      console.log(
        "Contact us page language " + localStorage.getItem("contactus")
      );
      this.setState({ contactUsStatus: 1 });
      localStorage.removeItem("contactus");
    }
  }

  onCaptchaChange(token) {
    this.setState({ recaptchaToken: token, recaptchaError: null });
  }

  onCaptchaExpired() {
    this.setState({ recaptchaToken: null, recaptchaError: "Captcha expired. Please verify again." });
  }

  contactUsForm(values) {
    // ✅ Block submit if captcha not completed
    if (!this.state.recaptchaToken) {
      this.setState({ recaptchaError: "Please verify captcha before submit." });
      return;
    }

    values["language"] = this.props.lang;
    values["planOrigin"] = localStorage.getItem("planOrigin");

    // ✅ Send captcha token to Laravel API
    values["captcha_token"] = this.state.recaptchaToken;

    console.log(values);
    $("#contactus-loader").show();
    this.refs.sbmt.setAttribute("disabled", "disabled");

    this.props.contact(values, this.refs.sbmt, (response) => {
      if (response === "success") {
        this.props.reset("contactUsValidation");
        $("#contactus-loader").hide();

        // reset captcha token after success
        this.setState({ recaptchaToken: null, recaptchaError: null });

        setTimeout(function () {
          window.location = "/";
        }, 10000);
      } else {
        // if failed, re-enable submit
        $("#contactus-loader").hide();
        this.refs.sbmt.removeAttribute("disabled");
      }
    });
  }

  renderInput(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <input
          type={field.type}
          className="form-control"
          placeholder={field.placeholder}
          autoComplete="off"
          {...field.input}
        />
        {field.meta.touched && field.meta.error && (
          <small className="text-danger">{field.meta.error}</small>
        )}
      </div>
    );
  }

  renderTextarea(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <textarea
          type={field.type}
          className="form-control md-textarea"
          placeholder={field.placeholder}
          {...field.input}
        ></textarea>
        {field.meta.touched && field.meta.error && (
          <small className="text-danger">{field.meta.error}</small>
        )}
      </div>
    );
  }

  errorMessage() {
    if (this.props.contactUsError !== null && this.props.contactUsError !== "") {
      return (
        <div className="col-md-12 alert alert-danger" role="alert">
          {this.props.contactUsError}
        </div>
      );
    }
    if (
      this.props.contactUsMessage !== null &&
      this.props.contactUsMessage !== ""
    ) {
      return (
        <div className="col-md-12 alert alert-success" role="alert">
          {this.props.contactUsMessage}
        </div>
      );
    }
  }

  render() {
    const firstname = (
      <FormattedMessage id="contact.us.name" defaultMessage="Name *" />
    );
    const emailaddress = (
      <FormattedMessage
        id="contact.us.emailaddress"
        defaultMessage="Email address *"
      />
    );
    const yourmessage = (
      <FormattedMessage
        id="contact.us.message"
        defaultMessage="Your message *"
      />
    );
    const phoneno = (
      <FormattedMessage
        id="contact.us.phone"
        defaultMessage="Tél. No* (Ex.: 0983200015)"
      />
    );

    // ✅ Put your site key here OR use env variable
    // If your build supports env: process.env.REACT_APP_RECAPTCHA_SITE_KEY
    const RECAPTCHA_SITE_KEY_NEW = "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";
    const RECAPTCHA_SITE_KEY =
      RECAPTCHA_SITE_KEY_NEW || "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";

    return (
      <React.Fragment>
        <section id="contact-page" className="mb-4 pages">
          <div className="container">
            {this.props.contactUsMessage === null ? (
              <div className="col-md-10">
                {this.state.contactUsStatus === 1 ? (
                  <h5 className="h1-responsive font-weight-bold text-center my-4">
                    <FormattedMessage
                      id="contact-us.header_title"
                      defaultMessage="Contact us"
                    />
                  </h5>
                ) : (
                  <h2 className="h1-responsive font-weight-bold text-center my-4">
                    <FormattedMessage
                      id="head.contactus"
                      defaultMessage="Contact us"
                    />
                  </h2>
                )}

                <p className="text-center w-responsive mx-auto mb-5">
                  {this.state.contactUsStatus === 1 ? (
                    <FormattedMessage
                      id="contact-us.header_subtitle"
                      defaultMessage="Do you have any questions? Please do not hesitate to contact us directly. Our team will come back to you soon."
                    />
                  ) : (
                    ""
                  )}
                </p>
              </div>
            ) : (
              ""
            )}

            <div className="Home-btn show-desktop">
              <Link
                className="btn btn-primary p-link client-info-block"
                style={{
                  background: "white",
                  padding: "10px 10px",
                  pointerEvents: "none",
                }}
              >
                <div className="client-btn">
                  <img
                    className="oliver-img"
                    src="assets/images/AGENDA_IMAGE.jpg"
                    alt=""
                  />
                  <b>
                    <p style={{ marginBottom: "0px", color: "black" }}>
                      <FormattedHTMLMessage
                        id="home.titlebtn"
                        defaultMessage="FAQ"
                      />
                    </p>
                  </b>
                </div>
              </Link>
              <a href="https://calendly.com/plateforme-pilotrh-evaluation-des-talents">
                <button className="info-btn">
                  <FormattedHTMLMessage
                    id="home.title.btn"
                    defaultMessage="FAQ"
                  />
                </button>
              </a>
            </div>

            <div className="row">
              {this.props.contactUsMessage != null ? (
                <div className="col-md-12 p-4 m-0 text-center">
                  {this.errorMessage()}
                  <div className="col-sm-12 mx-auto text-center mb-4 pb-45">
                    <Link to="/" className="btn btn-warning mt-3 mx-3">
                      <FormattedMessage
                        id="goto_home"
                        defaultMessage="HOME PAGE"
                      />
                    </Link>
                  </div>
                </div>
              ) : (
                <form
                  id="contact-form"
                  onSubmit={this.props.handleSubmit((e) => this.contactUsForm(e))}
                  className="row w-100"
                >
                  <div className="col-lg-10 col-md-10 p-0 m-0">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="md-form mb-0">
                          <Field
                            name="name"
                            type="text"
                            label={firstname}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="md-form mb-0">
                          <Field
                            name="email"
                            type="email"
                            label={emailaddress}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="md-form mb-0">
                          <Field
                            name="phoneno"
                            type="text"
                            label={phoneno}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="md-form">
                          <Field
                            name="message"
                            type="textarea"
                            label={yourmessage}
                            placeholder=""
                            className="form-control md-textarea"
                            rows="2"
                            component={this.renderTextarea}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ✅ CAPTCHA added here (just above submit button) */}
                    <div className="row">
                      <div className="col-md-12 text-center" style={{ marginTop: 10 }}>
                        <ReCAPTCHA
                          sitekey={RECAPTCHA_SITE_KEY}
                          onChange={this.onCaptchaChange}
                          onExpired={this.onCaptchaExpired}
                        />
                        {this.state.recaptchaError ? (
                          <small className="text-danger d-block mt-2">
                            {this.state.recaptchaError}
                          </small>
                        ) : null}
                      </div>
                    </div>

                    <div className="col-md-12 text-center">
                      <div
                        className="spinner-border text-primary m-auto"
                        role="status"
                        id="contactus-loader"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>

                    <div className="col-md-12 text-center">
                      <button
                        type="submit"
                        name="send-query"
                        id="send-query"
                        tabIndex="4"
                        className="btn btn-primary"
                        ref="sbmt"
                        disabled={!this.state.recaptchaToken} // ✅ no other change, only prevent submit until captcha
                      >
                        <FormattedMessage id="submit" defaultMessage="SUBMIT" />
                      </button>
                    </div>

                    <div className="status"></div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>

        <section className="client-info-block" id="info-block">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="Home-btn">
                  <Link
                    className="btn btn-primary p-link client-info-block"
                    style={{
                      padding: "10px 10px",
                      pointerEvents: "none",
                    }}
                  >
                    <div className="client-btn">
                      <img
                        className="oliver-img"
                        src="assets/images/AGENDA_IMAGE.jpg"
                        alt=""
                      />
                      <b>
                        <p style={{ marginBottom: "0px", color: "black" }}>
                          <FormattedHTMLMessage
                            id="home.titlebtn"
                            defaultMessage="FAQ"
                          />
                        </p>
                      </b>
                    </div>
                  </Link>
                  <a href="https://calendly.com/plateforme-pilotrh-evaluation-des-talents">
                    <button className="info-btn">
                      <FormattedHTMLMessage
                        id="home.title.btn"
                        defaultMessage="FAQ"
                      />
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </React.Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.email) {
    errors.email = "Email address is required";
  }
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.username = "Invalid email";
  }

  if (!values.phoneno) {
    errors.phoneno = "Phone No. is required";
  } else {
    const phoneRegex = /^\+?\d+(?: ?\d+)?$/;
    if (!phoneRegex.test(values.phoneno)) {
      errors.phoneno = "Phone number is not valid.";
    } else {
      const digitsOnly = values.phoneno.replace(/[ +]/g, "");
      if (digitsOnly.length <= 10 && digitsOnly.length >= 15) {
        errors.phoneno = "Phone number is not valid.";
      }
    }
  }

  if (!values.message) {
    errors.message = "Message is required";
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
    contactUsValidation: state.form.contactUsValidation,
    contactUsError: state.auth.contactUsError,
    contactUsMessage: state.auth.contactUsMessage,
    lang: state.locale.lang,
  };
};

Contactus = connect(mapStateToProps, { contact, clearContactMessage })(Contactus);

export default reduxForm({
  form: "contactUsValidation",
  enableReinitialize: true,
  validate,
})(Contactus);
